import React from 'react';
import * as Images from '../../assets';

const FeaturesPage = () => {
    return (
        <section id="features">
            <div className="max-w-full mx-auto bg-white">
                <hr />
                <h1 className="text-center text-3xl md:text-4xl font-bold mb-4 mt-10">Created solely for gated communities</h1>
                <p className="text-center text-gray-600 mb-8">Revolutionize your community management with simple solutions for security, maintenance, and more</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    <div className="relative">
                        <img src={Images.feature_1} alt="Family enjoying a picnic in a park" className="w-full h-auto rounded-lg" />
                    </div>
                    <div className="flex flex-col justify-center ml-12 2xl:mr-40 xl:mr-40 l:mr-20 md:mr-20 sm:mr-10 xs:mr-10">
                        <h2 className="text-3xl font-bold mb-4">Your go-to Partner in Community Management</h2>
                        <p className="text-gray-600 mb-4">Smart Chokidar is dedicated to simplifying life in your housing society and making it more secure with an arsenal of effective tools for security, communication, and management of the community.</p>
                        <h3 className="font-bold">Key features</h3>
                        <div className="custom-two-column-list mt-5">
                            <ul>
                                <li className="flex items-center">🏠 {" "}Guest Management</li>
                                <li className="flex items-center">🛠️ {" "}Domestic Staff Management</li>
                                <li className="flex items-center">💳 {" "}Maintenance & Utility Bill Payments</li>
                            </ul>
                            <ul>
                                <li className="flex items-center">🚨 {" "}Emergency Alerts</li>
                                <li className="flex items-center">📣 {" "}Communications Management</li>
                                <li className="flex items-center">📝 {" "}Complaint Tracking</li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    {/* Image Section */}
                    <div className="relative order-1 md:order-2">
                        <img
                            src={Images.feature_2}
                            alt="Group of people discussing in an office"
                            className="w-full h-auto rounded-lg"
                        />
                    </div>

                    {/* Content Section */}
                    <div className="flex flex-col justify-center ml-10 mr-4 md:ml-40 md:mr-16 sm:ml-20 xs:ml-20 order-2 md:order-1">
                        <h2 className="text-3xl font-bold mb-4">Why Choose Smart Chokidar?</h2>
                        <p className="text-gray-600 mb-4">
                            We provide an integrated set of features to automate daily routines and enhance the general resident experience, centered around security, simplicity, and innovation.
                        </p>
                        <h3 className="font-bold mb-2">Key features</h3>
                        <div className="custom-two-column-list mt-5">
                            <ul>
                                <li className="flex items-center">🚪 Visitor Access Control</li>
                                <li className="flex items-center">🔔 Real-Time Alerts & Notifications</li>
                                <li className="flex items-center">💸 Automated Billing & Payments</li>
                            </ul>
                            <ul>
                                <li className="flex items-center">🔒 Encrypted Communication Channels</li>
                                <li className="flex items-center">📊 Data Insights & Analytics</li>
                                <li className="flex items-center">🗣️ Simple Complaint Resolution</li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    <div className="relative">
                        <img src={Images.feature_3} alt="Family enjoying a picnic in a park" className="w-full h-auto rounded-lg" />
                    </div>
                    <div className="flex flex-col justify-center ml-12 2xl:mr-40 xl:mr-40 l:mr-20 md:mr-20 sm:mr-10 xs:mr-10">
                        <h2 className="text-3xl font-bold mb-4">Advertise with Us</h2>
                        <p className="text-gray-600 mb-4">Partner with Smart Chokidar to market your products and services to a very active community of residents. Expand your brand while assisting in enhancing the lives of people around you.</p>
                        <h3 className="font-bold mb-2">Key features</h3>
                        <div className="custom-two-column-list mt-5">
                            <ul>
                                <li className="flex items-center">📈 Direct Reach to Residents</li>
                                <li className="flex items-center">🎯 Adjustable Ad Placements</li>
                                <li className="flex items-center">🛒 Local Service Targeted Promotions</li>
                            </ul>
                            <ul>
                                <li className="flex items-center">👀 Higher Exposure for Your Business</li>
                                <li className="flex items-center">💬 Engagement with Residents</li>
                                <li className="flex items-center">📊 Real-Time Performance Monitoring</li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Image Section */}
                    <div className="relative order-1 md:order-2">
                        <img
                            src={Images.feature_4}
                            alt="Group of people discussing in an office"
                            className="w-full h-auto rounded-lg"
                        />
                    </div>

                    {/* Content Section */}
                    <div className="flex flex-col justify-center ml-10 mr-4 md:ml-40 md:mr-16 sm:ml-10 xs:ml-10 order-2 md:order-1">
                        <h2 className="text-3xl font-bold mb-4">Get Started with Smart Chokidar Today</h2>
                        <p className="text-gray-600 mb-4">
                            Enroll your community today and be part of thousands of other communities that are already enjoying hassle-free management, increased security, and improved communication.
                        </p>
                        <h3 className="font-bold mb-2">Key features</h3>
                        <div className="custom-two-column-list mt-5">
                            <ul>
                                <li className="flex items-center">✍️ Society Registration</li>
                                <li className="flex items-center">🏁 Simple Setup Process</li>
                                <li className="flex items-center">📱 Intuitive Interface</li>
                            </ul>
                            <ul>
                                <li className="flex items-center">📊 Detailed Dashboard</li>
                                <li className="flex items-center">🏘️ Resident Onboarding Made Easy</li>
                                <li className="flex items-center">🚀 Quick Integration & Support</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default FeaturesPage
